<template>
  <div class="studio-Details-container">
    <div class="studio-details">
      <div class="studio-bg-image">
        <div class="md-layout md-alignment-center-center">
          <h1
            class="section-title"
            v-html="studiosDetails.title"
          />
        </div>
        <div class="md-layout md-alignment-center-center">
          <p>
            Studio Master:&nbsp;<span
              v-html="studiosDetails.field_master"
            />
          </p>
        </div>
      </div>
    </div>
    <div class="studio-project"> 
      <div class="md-layout project-details studio-margin"> 
        <div class="md-layout-item md-xlarge-size-50 md-large-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100">
          <img :src="studiosDetails.field_image">
        </div>
        <div class="md-layout-item md-size-5" />
        <div class="studio-body md-layout-item md-xlarge-size-45 md-large-size-45 md-medium-size-45 md-small-size-100 md-xsmall-size-100">
          <p v-html="studiosDetails.body" />
        </div>
      </div>
      <md-tabs
        md-alignment="centered"
      >
        <md-tab
          id="tab-projects"
          md-label="Studio Projects"
        >
          <div class="project-notice">
            <studio-project-list
              :studio-projects="projectData"
              @current-index="setCurrentIndex"
            />
          </div>
          <div
            class="studio-project-details"
          >
            <div class="project-details">
              <div class="md-layout md-alignment-center-center">
                <h1 v-html="studioData.title" />
              </div>
              <p v-html="studioData.body" />
            </div>
            <div v-if="isPhotography">
              <studio-photo :project="studioData" />
            </div>
            <div v-if="isVideo">
              <studio-video
                :project="studioData.field_media"
                :author="studioData.apprentices"
              />
            </div>
            <div v-if="isAudio">
              <studio-audio :project="studioData.field_media" />
            </div>
          </div>
        </md-tab>
        <md-tab
          id="tab-team"
          md-label="Studio Team"
        >
          <div
            v-show="artists.length"
            class="md-layout md-alignment-center-center artists"
          >
            <template v-for="(artist, index) in artists">
              <studio-artists
                :key="index"
                :title="artist.title"
                :image="artist.field_image"
                :studio-master="artist.field_master"
              />
            </template>
          </div>
        </md-tab>
      </md-tabs> 
    </div>
    <div class="studio-navigation">
      <studio-navigation 
        :id="$route.params.id"
        class="studio-margin"
        :studios="studioIds"
        @scroll="scrollToTop"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import StudioPhoto from './StudioPhoto'
import StudioVideo from './StudioVideo'
import StudioAudio from './StudioAudio'
import StudioArtists from './StudioArtists'
import StudioProjectList from './StudioProjectList'
import StudioNavigation from './StudioNavigation'
export default {
  name: "StudioDetails",
  components: {
    StudioPhoto,
    StudioArtists,
    StudioNavigation,
    StudioProjectList,
    StudioVideo,
    StudioAudio
  },
  data() {
    return {
      projectData: [],
      studioData: {}
    }
  },
  computed: {
    ...mapState(['studios']),
    ...mapGetters({
      studiosDetails: 'getStudiosDetails',
      artists: 'getArtists',
      studioIds: 'getStudiosIds',
      projects: 'studioProjects'
    }),
    isPhotography() {
      return Object.keys(this.studioData).length > 0 && this.studioData.field_category === 'Photography'
    },
    isVideo() {
      return Object.keys(this.studioData).length > 0 && this.studioData.field_category === 'Video'
    },
    isAudio() {
      return Object.keys(this.studioData).length > 0 && this.studioData.field_category === 'Audio'
    }
  },
  watch: {
    '$route' (to, from) {
      this.getStudioDetails(to.params.id)
    },
    projects (value) {
      this.projectData = value
    }
  },
  async created() {
    await this.getStudios()
    await this.getStudioDetails(this.$route.params.id)
  },
  methods: {
    resetData () {
      this.projectData = [],
      this.studioData = {}
    },
    async setCurrentIndex (value) {
      await this.$nextTick()
      if (this.projectData.length) {
        this.studioData = this.projectData[value]
        return
      }
      this.studioData = {}
    },
    async getStudioDetails(id) {
      const loader = this.$loading.show({
        container: null,
        canCancel: true,
      })
      try {
        this.resetData()
        await this.$nextTick()
        await Promise.all([
          await this.$store.dispatch('getStudiosDetails', id),
          await this.$store.dispatch('getStudioArtists', id),
          await this.$store.dispatch('getStudioProjects', id)
        ])
        loader.hide()
      } catch (error) {
        loader.hide()
        throw Error(error)
      }
    },
    getStudios() {
      this.$store.dispatch('getStudios')
    },
    goToVideoTour() {
      window.location.replace('/tour')
    },
    scrollToTop() {
      window.scroll(0, 0)
    }
  }
}
</script>
<style lang="scss">
.studio-project {
  .md-tab {
    padding: 0 !important;
  }
  .md-tabs-navigation .md-button {
    font-weight: bold;
    font-size: 21px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.48;
    letter-spacing: normal;
    text-transform: capitalize;
  }
}
</style>
<style lang="scss" scoped>
.studio-Details-container {
  .studio-margin {
    margin: auto 13% auto 10%;
  }
  .studio-details {
    min-height: 30vh;
    margin-bottom: 20px;
    color: $color-white;
    background-blend-mode: multiply;
    background-image: linear-gradient(to left, #000000, #0c0a0b);

    .studio-bg-image {
      background: url('~@/assets/studio-bg.png');
      background-size: cover;
    }

    h1, h2 {
      &.section-title {
        margin: 0;
        position: relative;
        margin-top: 100px; 
        font-size: 66px;
        font-weight: bold;
        color: $color-white;
      }
    }
    .section-sub-title {
      width: 50%;
      margin-top:100px;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #e0eaf2;
    }
    p {
      margin-top: 40px;
    }
  }
  .studio-project {
    width: 100%;
    min-height: 45vh;
    .artists {
      @extend .studio-margin;
      margin-top: 20px;
    }
    .md-tabs-navigation .md-button {
      font-weight: bold;
    }
  }
  .studio-project-details {
    @extend .studio-margin;
  }
  .project-details { 
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    margin-bottom: 20px;
    color: #505d68;
    h1 {
      color: $color-black;
    }
    .studio-body {
      max-height: 45vh;
      overflow-y: scroll;
    }
  }
  .project-notice {
    margin-top: 11px;
    margin-bottom: 20px;
    span {
      font-size: 26px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: $color-primary;
      cursor: pointer;
    }
    p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: italic;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #505d68;
    }
  }
}
@media only screen and (max-width: 600px) {
  .studio-Details-container {
    .studio-details {
      h1, h2 {
        &.section-title { 
          font-size: 30px;
        }
       }
    }
  }
}
</style>